'use strict';

export function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
  'ngInject';

  var state;
  return {
    // Add authorization token to headers
    request(config) {
      config.headers = config.headers || {};

      // Skip auth for S3 URLs (checks for AWS signature parameters)
      if (config.url.includes('X-Amz-Signature') ||
          config.url.includes('AWSAccessKeyId') ||
          config.url.includes('.s3.') ||
          config.url.includes('amazonaws.com')) {
        return config;
      }

      // Get token from cookies
      const token = $cookies.get('token');
      if(token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // You could add additional headers if needed
      config.headers['Content-Type'] = 'application/json';

      return config;
    },

    // Intercept 401s and redirect you to login
    responseError(response) {
      if(response.status === 401 && !response.config.skipAuthRedirect) {
        // Get current state/route
        const currentPath = $injector.get('$location').path();

        // Only redirect to login if not already on homepage
        if (currentPath !== '/') {
          (state || (state = $injector.get('$state')))
            .go('login');

          // remove any stale tokens
          $cookies.remove('token');
        }
      }
      return $q.reject(response);
    }
  };
}



// WEBPACK FOOTER //
// ./client/components/auth/interceptor.service.js